export default "__VITE_ASSET__da13b5b4__"